export default __webpack_public_path__ + "static/media/microvessel-model2.d30d9c2a.jpg";